import React, { FC, useMemo, useCallback, useState } from 'react'
import makeStyles from '@mui/styles/makeStyles';
import DataGrid2, { IDataGrid2_Column } from '../../datagrid2/DataGrid'
import Window from '../../dialog/Window'
import FormTitle from '../../widgets/FormTitle'
import HelperText from '@kaidam/fc-shared/src/frontend/components/form/fields/HelperText'
import { getProps } from '@kaidam/fc-shared/src/frontend/components/form/fields/utils'

import {
  FormFieldProps,
} from '../../../types/form'

interface MetadataRow {
  name: string,
  value: string,
}

const columns: IDataGrid2_Column<MetadataRow>[] = [
  { name: 'name', header: 'Name', defaultFlex: 1, sortable: false, },
  { name: 'value', header: 'Value', defaultFlex: 1, sortable: false, },
]

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  gridContainer: {
    width: '100%',
    height: '200px',
    minHeight: '200px',
  },
}))

const MetadataField: FC<React.PropsWithChildren<FormFieldProps>> = (props) => {

  const {
    field: {
      name,
      value,
    },
    form: {
      setFieldValue,
    },
    error,
    disabled,
    touched,
    item,
  } = getProps(props)

  const classes = useStyles()
  
  const [ windowOpen, setWindowOpen ] = useState(false)
  const title = item.title || name

  const rows = useMemo<MetadataRow[]>(() => {
    const valueRows = Object
      .keys(value || {})
      .map((name, id) => ({
        id,
        name,
        value: value[name],
      }))

    const lastRow = valueRows[valueRows.length - 1]

    if(!lastRow || lastRow.name != '' || lastRow.value != '') {
      valueRows.push({
        id: valueRows.length,
        name: '',
        value: '',
      })
    }

    return valueRows
  },
  [
    value,
  ])

  const onUpdate = useCallback((rows: MetadataRow[]) => {
    if(disabled) return
    const values = rows.reduce<Record<string, string>>((all, row) => {
      all[row.name] = row.value
      return all
    }, {})
    setFieldValue(name, values)
  }, [
    disabled,
  ])

  return (
    <div className={classes.root}>
      <FormTitle
        title={ title }
        linkTitle="expand"
        onClick={ () => setWindowOpen(true) }
      />
      <div className={ classes.gridContainer }>
        <DataGrid2
          rows={ rows }
          editable={ disabled ? false : true }
          columns={ columns }
          onRowsChange={ onUpdate }
        />
      </div>
      
      <HelperText
        helperText={ item.helperText }
        error={ error ? true : false }
        touched={ touched }
      />

      {
        windowOpen && (
          <Window
            open
            noScroll
            compact
            fullHeight
            size="xs"
            cancelTitle="Close"
            withCancel
            onCancel={ () => setWindowOpen(false) }
          >
            <DataGrid2
              rows={ rows }
              editable={ disabled ? false : true }
              columns={ columns }
              onRowsChange={ onUpdate }
            />
          </Window>
        )
      }
    </div>
  )
}

export default MetadataField